// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import caseActivityEntity from './entities/case-activity.json';
import caseActivityMenu from '../pages/case-activity/menu.json';
import caseActivityFullForm from '../pages/case-activity/forms/full.json';
import caseActivityContextForm from '../pages/case-activity/forms/context.json';
import caseActivityMiniForm from '../pages/case-activity/forms/mini.json';
import caseActivityLookupForm from '../pages/case-activity/forms/lookup.json';
import caseActivityTableView from '../pages/case-activity/views/table.json';
import caseActivityCardsView from '../pages/case-activity/views/cards.json';
import caseActivityCalendarView from '../pages/case-activity/views/calendar.json';
import caseActivityDashboardView from '../pages/case-activity/views/dashboard.json';

/** Тип запису «Активність у справі» зі сторінками пакета: меню, форми та подання з pages/case-activity/. */
export const caseActivityDefinition: IRecordTypeDefinition = {
  ...caseActivityEntity,
  views: assembleViewSet({
      table: caseActivityTableView,
      cards: caseActivityCardsView,
      calendar: caseActivityCalendarView,
      dashboard: caseActivityDashboardView,
  }),
  form: caseActivityFullForm,
  forms: { full: caseActivityFullForm, context: caseActivityContextForm, mini: caseActivityMiniForm, lookup: caseActivityLookupForm },
  menu: caseActivityMenu,
} as IRecordTypeDefinition;
